import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum AccessGrantPermissionSet {
  View = 'access_grant_view',
  Write = 'access_grant_write',
}

// prettier-ignore
export const accessGrantPermissionSetGrouping: IPermissionSetGrouping<AccessGrantPermissionSet> = {
  key: PermissionSetGroupingKey.AccessGrant,
  active: {
    [AccessGrantPermissionSet.View]: [
      PermissionType.GET_ANY_ACCESS_GRANT,
    ],
    [AccessGrantPermissionSet.Write]: [
      /**
       * The user will also require permissions to fetch the objects.
       * But since this is arbitrary, we will not include them in the permission set.
       * and instead require the user to be part of a group that has the necessary grants to view the objects.
       */
      PermissionType.UPDATE_ANY_ACCESS_GRANT,
    ],
  },
  unAssignablePermissionSets: [],
}
